import Button from '../components/Button'
import { Link } from 'react-router-dom'
import ClearanceItems from './ClearanceItems.jsx'

function Home() {
  return (
    <div className='my-24'>
      <h1 className='text-4xl mb-6 text-center font-medium text-slate-800'>
        You are visiting
        <br />
        <span className='font-sans font-bold'>Plamar USA</span>
        <br />
        slab inventory
      </h1>
      <div className='text-center mt-20'>
        <Button>
          <Link to='/inventory'>View Inventory Now</Link>
        </Button>
      </div>
      <ClearanceItems />
    </div>
  )
}

export default Home
